import { makeStyles } from "@mui/styles";
import { ITheme } from "../../../common/theme";

export default makeStyles<ITheme>(() => ({
  alertRoot: {
    "& .MuiAlert-icon": {
      color: "inherit",
    },
  },
}));
